import React from 'react';
import IProps from './interface';
import { colors } from '../theme';

const IconRewriteCredits = ({
  color = colors.freeTrialDarkYellow,
  size = 17,
  className,
}: Pick<IProps, 'size' | 'color' | 'className'>) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 6.5C12.5 6.77614 12.2761 7 12 7C11.7239 7 11.5 6.77614 11.5 6.5H12.5ZM1.5 7.66602V4.8512H2.5V7.66602H1.5ZM1.5 4.8512C1.5 3.86651 2.37751 3.16602 3.33333 3.16602V4.16602C2.81582 4.16602 2.5 4.52626 2.5 4.8512H1.5ZM3.33333 3.16602H10.6667V4.16602H3.33333V3.16602ZM10.6667 3.16602C11.6225 3.16602 12.5 3.86651 12.5 4.8512H11.5C11.5 4.52627 11.1842 4.16602 10.6667 4.16602V3.16602ZM12.5 4.8512V6.5H11.5V4.8512H12.5Z"
        fill={color}
      />
      <path
        d="M7 13.833C7.27614 13.833 7.5 14.0569 7.5 14.333C7.5 14.6092 7.27614 14.833 7 14.833L7 13.833ZM3.33333 14.833C2.37751 14.833 1.5 14.1325 1.5 13.1478L2.5 13.1478C2.5 13.4728 2.81582 13.833 3.33333 13.833L3.33333 14.833ZM1.5 13.1478L1.5 4.85153L2.5 4.85153L2.5 13.1478L1.5 13.1478ZM1.5 4.85153C1.5 3.86683 2.37752 3.16634 3.33334 3.16634L3.33334 4.16634C2.81582 4.16634 2.5 4.52659 2.5 4.85153L1.5 4.85153ZM3.33334 3.16634L6.66667 3.16634L6.66667 4.16634L3.33334 4.16634L3.33334 3.16634ZM7 14.833L3.33333 14.833L3.33333 13.833L7 13.833L7 14.833Z"
        fill={color}
      />
      <path
        d="M14.5 8.1475C14.5 8.42364 14.2761 8.6475 14 8.6475C13.7239 8.6475 13.5 8.42364 13.5 8.1475H14.5ZM3.5 3.66602V2.8512H4.5V3.66602H3.5ZM3.5 2.8512C3.5 1.86651 4.37751 1.16602 5.33333 1.16602V2.16602C4.81582 2.16602 4.5 2.52626 4.5 2.8512H3.5ZM5.33333 1.16602H12.6667V2.16602H5.33333V1.16602ZM12.6667 1.16602C13.6225 1.16602 14.5 1.86651 14.5 2.8512H13.5C13.5 2.52627 13.1842 2.16602 12.6667 2.16602V1.16602ZM14.5 2.8512V8.1475H13.5V2.8512H14.5Z"
        fill={color}
      />
      <path d="M10.0025 5.99949H4" stroke={color} strokeLinejoin="round" />
      <path d="M9 8.66632H4" stroke={color} strokeLinejoin="round" />
      <path d="M8 11.3324H4" stroke={color} strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59998 14.267C9.52083 14.267 10.2673 15.0135 10.2673 15.9343C10.2673 15.0135 11.0138 14.267 11.9347 14.267C11.0138 14.267 10.2673 13.5205 10.2673 12.5996C10.2673 13.5205 9.52083 14.267 8.59998 14.267Z"
        fill={color}
        stroke={color}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.416 12.9673C13.3369 12.9673 14.0834 13.7139 14.0834 14.6347C14.0834 13.7139 14.8299 12.9673 15.7507 12.9673C14.8299 12.9673 14.0834 12.2208 14.0834 11.3C14.0834 12.2208 13.3369 12.9673 12.416 12.9673Z"
        fill={color}
        stroke={color}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2998 9.96735C11.2207 9.96735 11.9672 10.7139 11.9672 11.6347C11.9672 10.7139 12.7137 9.96735 13.6345 9.96735C12.7137 9.96735 11.9672 9.22085 11.9672 8.29999C11.9672 9.22085 11.2207 9.96735 10.2998 9.96735Z"
        fill={color}
        stroke={color}
        strokeWidth="0.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconRewriteCredits;
